export const BASE_URL_API = 'https://shop.qnnox.com/web/apis/'